import { Component, OnInit } from '@angular/core';
import { BankDetailService } from '../../../../components/service/bank-detail.service';
import { HttpService } from '../../../../components/service/http.service';
import { BankProfile } from '../../../../components/utils/bank-profile';
import { Constants } from '../../../../components/utils/constants';
import { SharedTranslateModule } from '../../../../utils/sharedTranslateModule';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { AddbankprofileComponent } from '../addbankprofile/addbankprofile.component';
import { EditbankprofileComponent } from '../editbankprofile/editbankprofile.component';
import { PrintComponent } from '../print/print.component';
import { ProfileverificationComponent } from '../profileverification/profileverification.component';
import { RouterOutlet, RouterModule } from '@angular/router';
import { PayCopyComponent } from '../../../../components/pay copy/paycopy.component';
import { WindowRef } from '../../../../utils/window';
import { AuthorizationService } from '../../../../components/authorization/authorization.service';

export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'dtf-removebankprofile',
    templateUrl: './removebankprofile.component.html',
    imports: [SharedTranslateModule, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule, 
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, RouterModule
    ]
})
export class RemovebankprofileComponent implements OnInit {
  
  REMOVEPROFILETEXT=Constants.REMOVEPROFILETEXT
  REMOVEPROFILECONFIRMATIONTEXT=Constants.REMOVEPROFILECONFIRMATIONTEXT
  continue: boolean=false;
  // form!: FormGroup;
  routingNum!: string;
  acctType!: string;
  bankName!: string;
  acctNum!: string;
  nameOnBankAcct!: string;
  email!: string;
  emailConfirm!: string;
  // continue: boolean=false;
  bankDetail: any;

  deleteBankProfile: BankProfile=new BankProfile;
  agentView: boolean;
  errmsg: any;
  blocked: boolean;
  loaded: boolean;
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;
  azURL: string;
  usUrl: string;
  agentview: string;


  constructor(private httpService:HttpService, private bankDetailService: BankDetailService,private _window: WindowRef, public auth: AuthorizationService) {
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
   }

  ngOnInit(): void {
    // if(sessionStorage.getItem('agentView')=="true"){
    //   this.agentView=true
    // }else{
    //  this.agentView=false
    // }
    this.agentview = sessionStorage.getItem('agentview');
        this.setFormValue();
  }

  setFormValue(){

    this.bankDetailService.getObject.subscribe((data: any) =>{
      this.deleteBankProfile.bankAcctId=data.id;
      // this.deleteBankProfile.ssn=data.ssn;
      // this.deleteBankProfile.dcsAccountNumber=data.dcsAccountNumber;
      this.deleteBankProfile.acctDescription=data.type;
      // this.deleteBankProfile.validateForDuplicate=data.validateForDuplicate;
      // this.deleteBankProfile.saveProfile=data.saveProfile;
      // this.deleteBankProfile.customerName=data.customerName;
      // this.deleteBankProfile.isCommercial=data.isCommercial;
      // this.deleteBankProfile.ACCT_CATEGORY_PERSONAL=data.ACCT_CATEGORY_PERSONAL;
      // this.deleteBankProfile.ACCT_CATEGORY_BUSINESS=data.ACCT_CATEGORY_BUSINESS;
      this.deleteBankProfile.bankAcctCategory=data.bankAccountCategory;
      //this.deleteBankProfile.bankAcctCategoryDesc=data.bankAcctCategoryDesc;
      //this.deleteBankProfile.shortAcctNum=data.shortAcctNum;
      //this.deleteBankProfile.csrfPreventionToken=data.csrfPreventionToken;
      //this.deleteBankProfile.autoPayBankProfile=data.autoPayBankProfile;
      //this.deleteBankProfile.reAuthCode=data.reAuthCode;
      //this.deleteBankProfile.custLoginId=data.custLoginId;
      this.deleteBankProfile.thirdPartyNum=data.thirdPartyNum;
      //this.deleteBankProfile.bankAccValStatus=data.bankAccValStatus;
      // this.deleteBankProfile.bankAccValRefId=data.bankAccValRefId;
      // this.deleteBankProfile.bankAccValTmstmp=data.bankAccValTmstmp;
      // this.deleteBankProfile.bankAccValRtnCode=data.bankAccValRtnCode;
      // this.deleteBankProfile.vendorServiceCall=data.vendorServiceCall;

      this.deleteBankProfile.routingNum=data.maskedRoutingNumber;
      this.deleteBankProfile.acctType=data.type;
      this.deleteBankProfile.bankName=data.bankName;
      this.deleteBankProfile.acctNum=data.maskedAccountNumber;
      this.deleteBankProfile.nameOnBankAcct= data.nameOnBankAcct;
      this.deleteBankProfile.email=data.email;
      this.deleteBankProfile.emailConfirm=data.emailConfirm;   
        
    })

    this.bankDetail={
      routingNum:this.routingNum,
      acctType:this.acctType,
      bankName:this.bankName,
      acctNum:this.acctNum,
      nameOnBankAccount:this.nameOnBankAcct,
      email:this.email,
      emailConfirm:this.emailConfirm} 
  }

  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

  onClickContinue(){
    const request1 = {
      "id": this.deleteBankProfile.bankAcctId
    }

    this.auth.deleteProfile(request1).subscribe(res => {
      if(res){
      this.continue = true;
      }
    
    }, error=>{
        if(error.status){
          this.errmsg=error.message
          this.blocked=true;
          this.loaded=true;
        }
  });
 
}

Done(){
  this._window.nativeWindow.location.href = '/home/bankprofile';
}
}
    

